import * as React from 'react';
import { map as _map, isEmpty as _isEmpty } from "lodash";


export interface ISummaryItem {
    items: string[],
    color: string
}

export interface ISummaryTopBarData{
    percent: number,
    color: string,
}

interface IBarChartSummaryOptions {
    height?: number
}

export interface IBarChartSummary {
    title:string,
    barChart : ISummaryTopBarData[]
    headings : string[],
    rows: ISummaryItem[],
    options?: IBarChartSummaryOptions
}

const BarChartSummary = (props: IBarChartSummary) => {

    const calculateLeftMargin = (index:number):string => {
        if(index===0 || props.barChart[index].percent==0) return "0px";
        let leftBarPresent = false;
        for(let i = index-1; i>=0; i--){
            if(props.barChart[i].percent > 0){ leftBarPresent = true; break;}
        }
        if(leftBarPresent) return "-7px" ;
        return "0px"
    }

    return (
        <React.Fragment>
            <div className="bar-chart-summary-title">{props.title}</div>
            <div className="bar-chart">
                {_map(props.barChart, (data: ISummaryTopBarData, index: number) => {
                    return <div key={index} style={{
                        width: `calc(${data.percent !== 0 ? data.percent+"% + 7px" : 0})`,
                        backgroundColor: data.color,
                        marginLeft: calculateLeftMargin(index),
                    }}>

                    </div>
                })}

            </div>
            <div className="summary-container">
                <div className="summary-heading">
                    {_map(props.headings, (heading:string, index:number)=>(
                        <span key={heading+index}>{heading}</span>
                    ))}
                </div>
                {
                    _map(props.rows, (row: ISummaryItem, index: number) => {
                        return <div key={index} className="summary-row" style={{
                            borderLeft: `4px solid ${row.color}`
                        }}>
                            {
                                _map(row.items, (item:string, i:number)=>(
                                    <span key={item+i}>{item}</span>
                                ))
                            }
                        </div>
                    })
                }
                <span></span>
            </div>
        </React.Fragment>
    )

}

export default BarChartSummary;


